const T = { debt_ratio: 33, interest_ratio: 5, receivable_ratio: 49 };

export function aaoifiScore(s) {
  if (!s || !s.verdict || s.verdict === "unverified") return null;
  const margins = [];
  const excesses = [];
  for (const [key, th] of Object.entries(T)) {
    const v = Number(s[key]);
    if (!Number.isFinite(v)) continue;
    margins.push(Math.max(0, Math.min(1, 1 - v / th)));
    excesses.push(Math.max(0, Math.min(1, v / th - 1)));
  }
  const avgMargin = margins.length ? margins.reduce((a, b) => a + b, 0) / margins.length : 0.5;
  const avgExcess = excesses.length ? excesses.reduce((a, b) => a + b, 0) / excesses.length : 0.5;
  if (s.verdict === "compliant") return Math.round(70 + 30 * avgMargin);
  if (s.verdict === "borderline") return Math.round(40 + 29 * avgMargin);
  if (s.verdict === "non_compliant") return Math.round(39 * (1 - avgExcess));
  return null;
}

export function scoreColor(score) {
  if (score == null) return "#71717a";
  if (score >= 70) return "#22c55e";
  if (score >= 40) return "#f59e0b";
  return "#ef4444";
}
